import React, { useState, useEffect } from 'react';
import Image from 'next/image';

import BookingSearchBar from '../templates/index/BookingSearchBar';
import {useSelector} from "react-redux";
import {fetchBuilderSettingByKey} from "../../helpers/MethodHelper";
import Checkers from "../../helpers/class/Checkers";

const MOTTO_FONT_SIZE_CSS = `
  .line-height-1-2 { line-height: 1.2 !important; }
  .fs-30 { font-size: 30px !important; }
  @media (min-width: 768px) {
    .fs-md-35 { font-size: 35px !important; }
  }
  @media (min-width: 992px) {
    .fs-lg-60 { font-size: 60px !important; }
  }
`;

export default function Motto ( props ) {

  const isMobile = useSelector(state => state['appSettings']['isMobile'])
  const isTablet = useSelector(state => state['appSettings']['isTablet'])
  const isDesktop = useSelector(state => state['appSettings']['isDesktop'])
  const isHomePage = useSelector(state => state['appSettings']['isHomePage'])


  const app = useSelector(state => state['builderSettingsData']['settings'])

  const {isFlexible} = props

  const logo = app.logoDecoration


  let jumbotronTextAlign = null;
  let jumbotronTextColor = null;

  //---------------- TEXT ALIGNMENT ----------------
  if (props.jumbotronTextAlign == 0)
    jumbotronTextAlign = 'align-items-start text-left justify-content-start';
  else if (props.jumbotronTextAlign == 1)
    jumbotronTextAlign = 'align-items-center text-center justify-content-center';
  else if (props.jumbotronTextAlign == 2)
    jumbotronTextAlign = 'align-items-end text-right justify-content-center';
  else
    jumbotronTextAlign = 'align-items-start';

  //---------------- TEXT COLOR ----------------
  if (props.jumbotronTextColor)
    jumbotronTextColor = 'text-white';
  else
    jumbotronTextColor = 'text-black';

  //---------------- TEXT BOLD ----------------
  if (props.sliderTitleBold)
    jumbotronTextColor += '\ bold';

  const [headerHeight, setHeaderHeight] = useState<number | null>(null);

  useEffect(() => {
    if (!props.sliderSearchBarBelowHeader) return;
    const header = document.querySelector('.Header') as HTMLElement | null;
    if (!header) return;
    const measure = () => setHeaderHeight(header.offsetHeight);
    measure();
    const observer = new MutationObserver(measure);
    observer.observe(header, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('resize', measure);
    return () => { observer.disconnect(); window.removeEventListener('resize', measure); };
  }, [props.sliderSearchBarBelowHeader]);

  const homepageMottoOverride = useSelector(
      state => fetchBuilderSettingByKey(state['builderSettingsData'], 'builder_homepage_motto_overide')
  );

  const homeTitleMotto = () => {
    return (
        Checkers.isValidString(homepageMottoOverride) ?
            <span dangerouslySetInnerHTML={{__html: homepageMottoOverride}}/>
            :
            props.homeTitle
    )
  }

  return (
      <div className="motto inner full-height position-absolute top-0 h-100 w-100" style={{pointerEvents: 'none'}}>
        {(!!props.sliderSearchBarBelowHeader && (isDesktop || isTablet) && headerHeight !== null) ? (
          <div style={{position: 'absolute', top: headerHeight, left: 0, right: 0, zIndex: 100, textAlign: 'left'}}>
            <BookingSearchBar
                isManager={props.isManager}
                sliderSearchBar={true}
                designMode={props.designMode}
                searchbarThemeColor={props.hasOwnProperty('searchbarThemeColor') ? props.searchbarThemeColor : null}
                rgbaDesignColor={props.rgbaDesignColor}
                searchbarRadius={props.searchbarRadius}
                searchbarShadow={props.searchbarShadow}
                bookingSearchbarWithBedrooms={props.bookingSearchbarWithBedrooms}
                isHomePage={true}
                isFlexible={isFlexible}
                bookingTypeValue={props.bookingTypeValue}
                webHotelierRoomCodes={props.webHotelierRoomCodes}
                webHotelierBookUrl={props.webHotelierBookUrl}
                propertyBookingTypeValue={props.propertyBookingTypeValue}
                managerInfo={props.managerInfo}
            />
          </div>
        ) : null}
        {(!!props.sliderSearchBarTop && (isDesktop || isTablet)) ? (
          <div style={{position: 'absolute', bottom: 24, left: 0, right: 0, zIndex: 100, textAlign: 'left'}}>
            <BookingSearchBar
                isManager={props.isManager}
                sliderSearchBar={true}
                designMode={props.designMode}
                searchbarThemeColor={props.hasOwnProperty('searchbarThemeColor') ? props.searchbarThemeColor : null}
                rgbaDesignColor={props.rgbaDesignColor}
                searchbarRadius={props.searchbarRadius}
                searchbarShadow={props.searchbarShadow}
                bookingSearchbarWithBedrooms={props.bookingSearchbarWithBedrooms}
                isHomePage={true}
                isFlexible={isFlexible}
                bookingTypeValue={props.bookingTypeValue}
                webHotelierRoomCodes={props.webHotelierRoomCodes}
                webHotelierBookUrl={props.webHotelierBookUrl}
                propertyBookingTypeValue={props.propertyBookingTypeValue}
                managerInfo={props.managerInfo}
            />
          </div>
        ) : null}
        <div className="container-xs-height full-height">
          <div className="col-xs-height col-middle text-left">
            <div className="row justify-content-center w-100 no-margin">
              <div className="col-12">
                <div className="container">
                  {
                    props.hasOwnProperty('hideMotto') ?
                        ''
                        :
                        <div className="row no-gutter">
                          <div
                              className={'col-sm-12 col-sm-offset-0 d-flex flex-column justify-content-center\ ' + jumbotronTextAlign + '\ ' + jumbotronTextColor + '\ z-index-3'}>
                            {
                              props.motto !== undefined || (isDesktop && props.logoDecoration != null) ?
                                  <>
                                    {
                                      isDesktop && props.logoDecoration != null ?
                                          <div className={"d-flex col-8 h-auto logo-decoration-div hidden-xs " + jumbotronTextAlign}>
                                            <Image
                                                loading={'eager'}
                                                width={props.logoDecorationOriginWidth}
                                                height={props.logoDecorationOriginHeight}
                                                objectFit={'contain'}
                                                className="image logo-decoration"
                                                alt={'logo_decoration'}
                                                src={props.logoDecoration}
                                                placeholder={'blur'}
                                                blurDataURL={'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='}
                                            />
                                          </div>
                                          : ''
                                    }
                                    {
                                      props.motto !== undefined ?
                                          <>
                                          <style>{MOTTO_FONT_SIZE_CSS}</style>
                                          {
                                            homeTitleMotto() != null || props.homeSubtitle != null ?

                                                homeTitleMotto() != null && props.homeSubtitle == null ?
                                                    <>
                                                      <h1
                                                          className={'font-montserrat m-b-0 p-b-20 fs-30 fs-md-35 fs-lg-60\ ' + jumbotronTextColor}
                                                          style={{textShadow: props.sliderTitleShadow ? '1px 1px 5px #333' : 'none'}}>{homeTitleMotto()}</h1>
                                                    </>
                                                    : props.homeSubtitle != null && homeTitleMotto() == null ?
                                                        <>
                                                          <p
                                                              className={'h3 font-montserrat fs-14 text-uppercase m-t-0 m-b-40\ ' + jumbotronTextColor}
                                                              style={{textShadow: props.sliderTitleShadow ? '1px 1px 5px #333' : 'none'}}>{props.homeSubtitle}</p>
                                                        </>
                                                        :
                                                        <>
                                                          <h1
                                                              className={'font-montserrat m-b-0 p-b-20 fs-30 fs-md-35 fs-lg-60 order-2 line-height-1-2 m-t-0\ ' + jumbotronTextColor}
                                                              style={{textShadow: props.sliderTitleShadow ? '1px 1px 5px #333' : 'none'}}>{homeTitleMotto()}</h1>
                                                          <p
                                                              className={'h3 font-montserrat fs-14 text-uppercase m-t-0 order-1\ ' + jumbotronTextColor}
                                                              style={{textShadow: props.sliderTitleShadow ? '1px 1px 5px #333' : 'none'}}>{props.homeSubtitle}</p>
                                                        </>
                                                :
                                                <>
                                                  <h1
                                                      className={'font-montserrat m-b-0 p-b-20 fs-30 fs-md-35 fs-lg-60\ ' + jumbotronTextColor}
                                                      style={{textShadow: props.sliderTitleShadow ? '1px 1px 5px #333' : 'none'}}>{props.motto}</h1>
                                                </>
                                          }
                                          </>
                                          : <></>
                                    }

                                  </>
                                  : ''
                            }
                          </div>
                        </div>
                  }
                </div>
              </div>
            </div>
            {
              props.sliderSearchBar == true && !props.sliderSearchBarBelowHeader && !props.sliderSearchBarTop && (isDesktop || isTablet) ?
                  <BookingSearchBar
                      isManager={props.isManager}
                      sliderSearchBar={true}
                      designMode={props.designMode}
                      searchbarThemeColor={props.hasOwnProperty('searchbarThemeColor') ? props.searchbarThemeColor : null}
                      rgbaDesignColor={props.rgbaDesignColor}
                      searchbarRadius={props.searchbarRadius}
                      searchbarShadow={props.searchbarShadow}
                      bookingSearchbarWithBedrooms={props.bookingSearchbarWithBedrooms}
                      isHomePage={true}
                      isFlexible={isFlexible}
                      bookingTypeValue={props.bookingTypeValue}
                      webHotelierRoomCodes={props.webHotelierRoomCodes}
                      webHotelierBookUrl={props.webHotelierBookUrl}
                      propertyBookingTypeValue={props.propertyBookingTypeValue}
                      managerInfo={props.managerInfo}
                  />
                  : ''
            }
          </div>
        </div>
      </div>
  )
}
